import { useMutation, useQueryClient } from '@tanstack/react-query'

import { request } from '../../../lib/axios'

export const cancelGoogleMCCRequest = async (accountId: number, connectionId: number) => {
  return await request({
    url: `/accounts/${accountId}/google/${connectionId}/mcc`,
    method: 'DELETE',
  })
}

export const useCancelGoogleMCCRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ accountId, connectionId }: { accountId: number; connectionId: number }) =>
      cancelGoogleMCCRequest(accountId, connectionId),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: ['getPlatformsConnections'] })
      void queryClient.invalidateQueries({ queryKey: ['googleAudiencesData'] })
      void queryClient.invalidateQueries({ queryKey: ['getPlatforms'] })
      void queryClient.invalidateQueries({ queryKey: ['getPlatformsGW'] })
    },
  })
}
